import { css } from '@/styled-system/css';

export const propertyCardPhotoWrapperStyles = css.raw({
  display: 'grid',
  gridArea: 'photo',
  gridTemplateAreas: `"photo-top" "photo-center" "photo-bottom"`,
  gridTemplateRows: 'auto 1fr auto',
});
